import get from "lodash/get";
import compact from "lodash/compact";
import isNil from "lodash/isNil";

/**
 * Utility functions for Ground Station contact station label and property formatting.
 * Uses Lodash utilities (get, compact, isNil) to safely format labels and prevent
 * undefined, null, or empty values from rendering on the UI.
 */

export const formatGsLabel = (c: any): string => {
  if (!c) return "";
  const name = String(get(c, "antennaId") || get(c, "groundStationName") || "").trim();
  const country = String(get(c, "groundStationProperties.country") || "").trim();

  const validParts = compact([name, country]).filter(
    (part) => part !== "undefined" && part !== "null"
  );

  return validParts.join(", ");
};

export const formatGsSubInfo = (val: any): string => {
  if (isNil(val)) return "";
  const str = String(val).trim();
  return str === "undefined" || str === "null" ? "" : str;
};
